export default {
  namespaced: true,
  state: {
    /** 内容类型 **/
    CONTENT_TYPE: {
      ACTIVITY: 1, // 活动
      ACTIVITY_SIGN: "activity_sign", //活动签到
      RAFFLE: 2, // 抽奖
      VOTE: 3, // 投票
      QUESTIONNAIRE: 10, // 问卷调查
      // RE_QUESTION: 17, // 问答
      INVITE: "invite", // 邀请
    },
    PAGE: {
      ACTIVITY: "/activity_detail", // 活动
      ACTIVITY_SIGN: "/sign_in", //活动签到
      RAFFLE: "/raffle_detail", // 抽奖
      VOTE: "/vote_detail", // 投票
      QUESTIONNAIRE: "/questionnaire_detail", // 问卷调查
      ANSWER: "/answer_detail", // 答题
      // RE_QUESTION: "/requestion_detail", // 问答
      INVITE: "invitation", // 邀请
    },
    nodeCode: process.env.VUE_APP_NODE_CODE, //企业code
    shareRootUrl: process.env.VUE_APP_SHARE_URL, //分享页地址
    token: window.localStorage.getItem("accessToken"),
    userInfo: JSON.parse(window.localStorage.getItem("userInfo")),
    statusBarHeight: isNaN(window.localStorage.getItem("statusBarHeight")) ? 0 : Number(window.localStorage.getItem("statusBarHeight")),
  },
  mutations: {
    SET_TOKEN(state, data) {
      state.token = data;
      window.localStorage.setItem("accessToken", data);
    },
    SET_USERINFO(state, data) {
      state.userInfo = data;
      localStorage.setItem("userInfo", JSON.stringify(data));
    },
    SET_STATUSBARHEIGHT(state, data) {
      state.statusBarHeight = data;
      localStorage.setItem("statusBarHeight", data);
    }
  },
  actions: {
    setToken({ commit }, data) {
      commit('SET_TOKEN', data)
    },
    setUserInfo({ commit }, data) {
      commit('SET_USERINFO', data)
    },
    setStatusBarHeight({ commit }, data) {
      commit('SET_STATUSBARHEIGHT', data)
    },
  },
  modules: {
  }
}